import { Box, Button, Input } from "@mui/material";
import { useState } from "react";
import { useDispatch } from "react-redux";
import saveIcon from "../../../assets/images/save.svg";
import { ReactComponent as FiltersIcon } from "../../../assets/images/filters.svg";
import styles from "../Graphs.module.scss";
import { getSnapshotId } from "utils/getTemplateSnapshotId";
import { postNewTemplate } from "store/templates/thunks";

type ReportToolbarProps = {
  cardId: number;
  isFiltersMenuOpen: boolean;
  isReportLoaded: boolean;
  isViewMode: boolean;
  providerId: number;
  reportPage: number;
  reportState: string;
  savedTemplateName: string;
  setIsFiltersMenuOpen: React.Dispatch<React.SetStateAction<boolean>>;
  setReportPage: React.Dispatch<React.SetStateAction<number>>;
  setShowSnackbar: React.Dispatch<React.SetStateAction<boolean>>;
};

const ReportToolbar = ({
  cardId,
  isFiltersMenuOpen,
  isReportLoaded,
  isViewMode,
  providerId,
  reportPage,
  reportState,
  savedTemplateName,
  setIsFiltersMenuOpen,
  setReportPage,
  setShowSnackbar,
}: ReportToolbarProps) => {
  const dispatch = useDispatch();
  const [templateName, setTemplateName] = useState<string>("");
  const [templateNameError, setTemplateNameError] = useState<boolean>(false);

  const handleSaveTemplate = async () => {
    if (templateName) {
      const snapshotId = getSnapshotId(providerId, cardId);
      dispatch(
        postNewTemplate({
          configuration: {
            providerId,
            cardId,
            template_state: reportState,
          },
          name: templateName,
          snapshot: snapshotId,
        })
      );
      setShowSnackbar(true);
    } else {
      setTemplateNameError(true);
    }
  };

  const handleTemplateNameChange = (
    event: React.ChangeEvent<HTMLInputElement>
  ) => {
    const value = event.target.value;
    if (value.length) setTemplateNameError(false);
    setTemplateName(value);
  };

  return (
    <Box
      sx={{
        display: "flex",
        justifyContent: "space-between",
        margin: "20px 24px 0 24px",
        position: "absolute",
        top: 0,
        visibility: isReportLoaded ? "visible" : "hidden",
        width: "95%",
      }}
    >
      {/* ==================== T E M P L A T E   N A M E   I N P U T ==================== */}
      <Box>
        <Box
          sx={{
            display: "flex",
            flexDirection: "column",
          }}
        >
          <Input
            className={styles.templateNameInput}
            disabled={isViewMode}
            disableUnderline
            error={templateNameError}
            placeholder="Template name"
            sx={{
              "&.Mui-error": {
                border: `1px solid ${styles.errorRed2}`,
              },
            }}
            value={isViewMode ? savedTemplateName : templateName}
            onChange={handleTemplateNameChange}
          />
          <span
            className={styles.templateNameHelperText}
            style={{
              visibility: templateNameError ? "visible" : "hidden",
            }}
          >
            {isViewMode ? savedTemplateName : "Template name is required."}
          </span>
        </Box>
      </Box>

      {/* ================= C H A N G E   R E P O R T   P A G E   B U T T O N ================= */}
      <Box
        sx={{
          display: "flex",
        }}
      >
        <Button
          className={styles.changeReportPageButton}
          disableElevation
          disableFocusRipple
          disableRipple
          sx={{
            marginRight: "24px",
            width: "115px",
            ":hover": {
              backgroundColor: styles.backgroundWhite,
            },
          }}
          onClick={() => {
            if (reportPage === 0) setReportPage(1);
            else setReportPage(0);
          }}
        >
          {reportPage === 0 ? "Maps View" : "Graph View"}
        </Button>

        {/* ================= Z O O M   A N D   F I L T E R S   B U T T O N S ================= */}
        <Box className={styles.whiteContainer}>
          {/* <Box display="flex" sx={{padding: "8px 0px"}} >
            -100+
          </Box>
          <Divider
            flexItem
            orientation="vertical"
            sx={{
              marginX: "12px",
              bgcolor: styles.dividerGray,
            }}
            variant="middle"
          /> */}
          <Button
            className={styles.filtersButton}
            disableElevation
            disableFocusRipple
            disableRipple
            endIcon={<FiltersIcon />}
            sx={{
              ":hover": {
                backgroundColor: "transparent",
              },
            }}
            onClick={() => {
              setIsFiltersMenuOpen(!isFiltersMenuOpen);
            }}
          >
            Filters
          </Button>
        </Box>

        {/* ==================== S A V E   T E M P L A T E   B U T T O N ==================== */}
        {!isViewMode && (
          <Button
            className={styles.saveTemplateButton}
            disableElevation
            disableFocusRipple
            disableRipple
            startIcon={
              <img
                alt="Save as template"
                height={24}
                src={saveIcon}
                width={24}
              />
            }
            sx={{
              width: "83px",
              ":hover": {
                backgroundColor: styles.mainBlue,
              },
            }}
            onClick={handleSaveTemplate}
          >
            Save
          </Button>
        )}
      </Box>
    </Box>
  );
};

export default ReportToolbar;
